module.exports = __webpack_public_path__ + "img/5.6fb871a0.jpg";